import moment from "moment";
import { isEmpty, verifyAuthToken } from "utils/utils";
import React, { useEffect, useState } from "react";
import { HOME_ROUTES } from "utils/route";
import { Link, useHistory } from "react-router-dom";
import { useStoreActions, useStoreState } from "easy-peasy";
import OutsideClickHandler from "react-outside-click-handler";
import brandLogo from "assets/images/brand-logo.png";

const Header = () => {
	const history = useHistory();
	const [isAppTrayOpen, setIsAppTrayOpen] = useState(false);
	const [isprofileOpen, setIsProfileOpen] = useState(false);
	const [activeTool, setActiveTool] = useState("");
	const authToken = useStoreState((state: any) => state.auth.authToken);
	const currentUser = useStoreState((state: any) => state.auth.currentUser);
	const clearAuthToken = useStoreActions(
		(actions: any) => actions.auth.clearAuthToken
	);
	const clearRefreshToken = useStoreActions(
		(actions: any) => actions.auth.clearRefreshToken
	);
	const fetchAirline = useStoreActions(
		(actions: any) => actions.cmsContent.fetchAirline
	);
	useEffect(() => {
		fetchAirline();
	}, []);

	return (
		<header className="header d-flex">
			<div className="header-left d-flex align-items-center p-l-10 p-r-10 justify-content-between">
				<Link to={"/"} className="d-flex">
					<img src={brandLogo} alt="" className="brand-logo" />
				</Link>
				{!isEmpty(authToken) && (
					<div className="header-menu__list m-t-5">
						<i
							className="material-icons"
							onClick={() => setIsAppTrayOpen(!isAppTrayOpen)}
						>
							apps
						</i>
						<div
							className={
								isAppTrayOpen
									? "applications-dropdown dropdown "
									: "applications-dropdown dropdown d-none"
							}
						>
							<OutsideClickHandler
								onOutsideClick={() => {
									setIsAppTrayOpen(false);
								}}
							>
								<h6 className="m-b-15">Applications</h6>
								<div className="menu-wrap d-flex align-items-center">
									{verifyAuthToken(authToken, "admin") && (
										<div
											className={
												activeTool === "Platform Admin"
													? "menu-item d-flex active flex-column align-items-center justify-content-between"
													: "menu-item d-flex flex-column align-items-center justify-content-between"
											}
											onClick={() => {
												setActiveTool("Platform Admin");
												history.push("/platformAdmin");
												setIsAppTrayOpen(false);
											}}
										>
											<svg
												width="24"
												height="24"
												viewBox="0 0 24 24"
												fill="none"
											>
												<path
													d="M9.77997 9.53333C11.9891 9.53333 13.78 7.74246 13.78 5.53333C13.78 3.32419 11.9891 1.53333 9.77997 1.53333C7.57083 1.53333 5.77997 3.32419 5.77997 5.53333C5.77997 7.74246 7.57083 9.53333 9.77997 9.53333Z"
													fill="white"
													className="path"
												/>
												<path
													d="M10.96 21.2134C10.7397 20.9955 10.5959 20.712 10.5502 20.4056C10.5046 20.0991 10.5594 19.786 10.7066 19.5134L11.06 18.8467L10.3333 18.6267C10.037 18.534 9.77901 18.3471 9.59854 18.0944C9.41806 17.8417 9.32494 17.5371 9.33331 17.2267V15.86C9.33275 15.551 9.43162 15.25 9.6153 15.0015C9.79898 14.753 10.0577 14.5702 10.3533 14.48L11.08 14.26L10.7333 13.5934C10.5904 13.3244 10.536 13.0172 10.5779 12.7156C10.6198 12.4139 10.7559 12.1332 10.9666 11.9134C10.4538 11.8461 9.93724 11.8105 9.41998 11.8067C7.8922 11.7707 6.3753 12.0724 4.97747 12.69C3.57965 13.3077 2.33535 14.2262 1.33331 15.38V20.5467C1.33331 20.7235 1.40355 20.8931 1.52858 21.0181C1.6536 21.1431 1.82317 21.2134 1.99998 21.2134H10.96Z"
													fill="white"
													className="path"
												/>
												<path
													d="M22.4665 15.64L21.1332 15.24C21.0408 14.9108 20.9111 14.5932 20.7465 14.2934L21.4132 13.0534C21.4389 13.0074 21.4484 12.954 21.4399 12.9019C21.4314 12.8498 21.4055 12.8022 21.3665 12.7667L20.3998 11.7934C20.3626 11.7571 20.3151 11.7332 20.2639 11.7249C20.2126 11.7165 20.16 11.7242 20.1132 11.7467L18.8798 12.4134C18.5763 12.2485 18.2569 12.1145 17.9265 12.0134L17.5198 10.68C17.502 10.6309 17.4693 10.5885 17.4263 10.5586C17.3833 10.5288 17.3322 10.513 17.2798 10.5134H15.8932C15.8412 10.5148 15.7909 10.5322 15.7492 10.5632C15.7074 10.5943 15.6762 10.6374 15.6598 10.6867L15.2598 12.02C14.9231 12.118 14.5987 12.2545 14.2932 12.4267L13.0865 11.76C13.0396 11.7351 12.986 11.7256 12.9334 11.7327C12.8808 11.7399 12.8317 11.7635 12.7932 11.8L11.8132 12.76C11.7746 12.7972 11.7492 12.846 11.7407 12.8989C11.7323 12.9518 11.7414 13.006 11.7665 13.0534L12.4332 14.2667C12.2546 14.5678 12.1093 14.8875 11.9998 15.22L10.6665 15.6267C10.6161 15.6413 10.5718 15.672 10.5405 15.7141C10.5092 15.7563 10.4926 15.8075 10.4932 15.86V17.2267C10.4926 17.2792 10.5092 17.3305 10.5405 17.3726C10.5718 17.4147 10.6161 17.4455 10.6665 17.46L11.9998 17.8667C12.0998 18.1932 12.2339 18.5083 12.3998 18.8067L11.7332 20.0734C11.708 20.1207 11.699 20.1749 11.7074 20.2279C11.7158 20.2808 11.7413 20.3295 11.7798 20.3667L12.7732 21.3334C12.8117 21.37 12.8608 21.3935 12.9134 21.4007C12.966 21.4079 13.0196 21.3983 13.0665 21.3734L14.3132 20.7067C14.6099 20.8663 14.9228 20.9937 15.2465 21.0867L15.6465 22.4534C15.6633 22.5038 15.6955 22.5476 15.7386 22.5787C15.7816 22.6098 15.8334 22.6266 15.8865 22.6267H17.2532C17.3052 22.6253 17.3554 22.6078 17.3972 22.5768C17.4389 22.5458 17.4701 22.5027 17.4865 22.4534L17.8865 21.0867C18.2064 20.9948 18.515 20.8674 18.8065 20.7067L20.0665 21.3734C20.1134 21.3983 20.167 21.4079 20.2196 21.4007C20.2723 21.3935 20.3213 21.37 20.3598 21.3334L21.3332 20.3667C21.3698 20.3282 21.3933 20.2791 21.4005 20.2265C21.4077 20.1739 21.3981 20.1203 21.3732 20.0734L20.7065 18.82C20.866 18.528 20.9934 18.2195 21.0865 17.9L22.4198 17.4934C22.4699 17.4773 22.514 17.4463 22.5461 17.4047C22.5782 17.363 22.597 17.3126 22.5998 17.26V15.88C22.6015 15.8317 22.5899 15.7838 22.5664 15.7416C22.543 15.6993 22.5084 15.6642 22.4665 15.64ZM16.5798 18.7867C16.1392 18.788 15.708 18.6586 15.341 18.4147C14.9739 18.1708 14.6875 17.8235 14.5179 17.4168C14.3484 17.01 14.3033 16.5621 14.3885 16.1297C14.4737 15.6974 14.6852 15.3 14.9963 14.9879C15.3075 14.6758 15.7042 14.4631 16.1363 14.3767C16.5684 14.2902 17.0165 14.3339 17.4237 14.5022C17.831 14.6706 18.1792 14.956 18.4241 15.3223C18.6691 15.6886 18.7998 16.1194 18.7998 16.56C18.7999 17.1494 18.5662 17.7148 18.15 18.1322C17.7339 18.5496 17.1692 18.7849 16.5798 18.7867Z"
													fill="white"
													className="path"
												/>
											</svg>
											<p>
												Platform <br /> Admin
											</p>
										</div>
									)}
									{!verifyAuthToken(authToken, "admin") &&
										verifyAuthToken(authToken, "account") && (
											<div
												className={
													activeTool === "Agency Admin"
														? "menu-item d-flex active flex-column align-items-center justify-content-between"
														: "menu-item d-flex flex-column align-items-center justify-content-between"
												}
												onClick={() => {
													setActiveTool("Agency Admin");
													history.push("/agencyAdmin");
													setIsAppTrayOpen(false);
												}}
											>
												<svg
													width="26"
													height="33"
													viewBox="0 0 26 33"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M21.814 17.7956C21.008 17.7956 20.332 18.4632 20.332 19.2593C20.332 20.0553 21.008 20.723 21.814 20.723C22.62 20.723 23.296 20.0553 23.296 19.2593C23.296 18.4376 22.646 17.7956 21.814 17.7956Z"
														fill="#EF4E58"
														className="path"
													/>
													<path
														d="M23.322 21.2622H20.306C19.578 21.2622 19.006 21.8785 19.006 22.5975V23.8558H24.622V22.5975C24.622 21.8528 24.05 21.2622 23.322 21.2622Z"
														fill="#EF4E58"
													/>
													<path
														d="M13.234 0.359497C12.428 0.359497 11.752 1.02715 11.752 1.8232C11.752 2.61925 12.428 3.2869 13.234 3.2869C14.04 3.2869 14.716 2.61925 14.716 1.8232C14.716 1.02715 14.04 0.359497 13.234 0.359497Z"
														fill="#EF4E58"
														className="path"
													/>
													<path
														d="M14.742 3.82611H11.726C10.998 3.82611 10.426 4.44241 10.426 5.16142V6.41969H16.042V5.16142C16.042 4.41673 15.444 3.82611 14.742 3.82611Z"
														fill="#EF4E58"
														className="path"
													/>
													<path
														d="M4.52399 17.7699C3.69199 17.7699 3.04199 18.4376 3.04199 19.2336C3.04199 20.0553 3.71799 20.6973 4.52399 20.6973C5.32999 20.6973 6.00599 20.0297 6.00599 19.2336C6.03199 18.4376 5.35599 17.7699 4.52399 17.7699Z"
														fill="#EF4E58"
														className="path"
													/>
													<path
														d="M6.058 21.2622H3.016C2.288 21.2622 1.716 21.8785 1.716 22.6232V23.8815H7.384V22.5975C7.358 21.8528 6.76 21.2622 6.058 21.2622Z"
														fill="#EF4E58"
														className="path"
													/>
													<path
														d="M23.738 13.8667C23.764 15.0222 23.582 16.1264 23.27 17.1792L24.102 17.9753C24.596 16.6913 24.83 15.279 24.804 13.8667C24.726 9.039 21.606 4.95604 17.264 3.33826L17.29 4.44245C21.008 6.00887 23.66 9.62962 23.738 13.8667Z"
														fill="#EF4E58"
														className="path"
													/>
													<path
														d="M2.39199 13.8667C2.36599 15.0222 2.54799 16.1264 2.85999 17.1792L2.02799 17.9753C1.53399 16.6913 1.29999 15.279 1.32599 13.8667C1.40399 9.039 4.52399 4.95604 8.86599 3.33826L8.83999 4.44245C5.12199 6.00887 2.46999 9.62962 2.39199 13.8667Z"
														fill="#EF4E58"
														className="path"
													/>
													<path
														d="M17.238 23.5476C15.964 24.0869 14.586 24.3693 13.104 24.3693C11.752 24.3693 10.452 24.1125 9.25601 23.676L8.47601 24.4464C9.90601 25.0627 11.466 25.3965 13.104 25.3965C14.872 25.3965 16.51 25.0113 17.992 24.318L17.238 23.5476Z"
														fill="#EF4E58"
														className="path"
													/>
													<g clipPath="url(#clip0)">
														<path
															d="M17.5067 10.6461H16.9121V11.4325C16.9121 11.5021 16.8846 11.5687 16.8357 11.6179C16.7868 11.6671 16.7204 11.6947 16.6512 11.6947C16.5821 11.6947 16.5157 11.6671 16.4668 11.6179C16.4179 11.5687 16.3904 11.5021 16.3904 11.4325V10.6461H8.49335C8.16708 10.6468 7.85437 10.7774 7.62367 11.0093C7.39296 11.2412 7.26305 11.5555 7.26236 11.8834V16.7487C7.26305 17.0767 7.39296 17.391 7.62367 17.6229C7.85437 17.8548 8.16708 17.9853 8.49335 17.986H16.3904V17.1996C16.3904 17.1301 16.4179 17.0634 16.4668 17.0143C16.5157 16.9651 16.5821 16.9375 16.6512 16.9375C16.7204 16.9375 16.7868 16.9651 16.8357 17.0143C16.8846 17.0634 16.9121 17.1301 16.9121 17.1996V17.986H17.5067C17.8329 17.9853 18.1457 17.8548 18.3764 17.6229C18.6071 17.391 18.737 17.0767 18.7377 16.7487V11.8834C18.737 11.5555 18.6071 11.2412 18.3764 11.0093C18.1457 10.7774 17.8329 10.6468 17.5067 10.6461ZM10.6528 16.4132H9.60958C9.54041 16.4132 9.47408 16.3856 9.42517 16.3364C9.37626 16.2873 9.34878 16.2206 9.34878 16.1511C9.34878 16.0815 9.37626 16.0149 9.42517 15.9657C9.47408 15.9165 9.54041 15.8889 9.60958 15.8889H10.6528C10.722 15.8889 10.7883 15.9165 10.8372 15.9657C10.8861 16.0149 10.9136 16.0815 10.9136 16.1511C10.9136 16.2206 10.8861 16.2873 10.8372 16.3364C10.7883 16.3856 10.722 16.4132 10.6528 16.4132ZM13.2608 13.7918H9.60958C9.54041 13.7918 9.47408 13.7642 9.42517 13.715C9.37626 13.6659 9.34878 13.5992 9.34878 13.5297C9.34878 13.4601 9.37626 13.3935 9.42517 13.3443C9.47408 13.2951 9.54041 13.2675 9.60958 13.2675H13.2608C13.33 13.2675 13.3963 13.2951 13.4452 13.3443C13.4941 13.3935 13.5216 13.4601 13.5216 13.5297C13.5216 13.5992 13.4941 13.6659 13.4452 13.715C13.3963 13.7642 13.33 13.7918 13.2608 13.7918ZM13.2608 12.7432H9.60958C9.54041 12.7432 9.47408 12.7156 9.42517 12.6665C9.37626 12.6173 9.34878 12.5506 9.34878 12.4811C9.34878 12.4116 9.37626 12.3449 9.42517 12.2957C9.47408 12.2466 9.54041 12.219 9.60958 12.219H13.2608C13.33 12.219 13.3963 12.2466 13.4452 12.2957C13.4941 12.3449 13.5216 12.4116 13.5216 12.4811C13.5216 12.5506 13.4941 12.6173 13.4452 12.6665C13.3963 12.7156 13.33 12.7432 13.2608 12.7432ZM16.9121 15.6268C16.9121 15.6963 16.8846 15.763 16.8357 15.8121C16.7868 15.8613 16.7204 15.8889 16.6512 15.8889C16.5821 15.8889 16.5157 15.8613 16.4668 15.8121C16.4179 15.763 16.3904 15.6963 16.3904 15.6268V15.1025C16.3904 15.033 16.4179 14.9663 16.4668 14.9171C16.5157 14.868 16.5821 14.8404 16.6512 14.8404C16.7204 14.8404 16.7868 14.868 16.8357 14.9171C16.8846 14.9663 16.9121 15.033 16.9121 15.1025V15.6268ZM16.9121 13.5297C16.9121 13.5992 16.8846 13.6659 16.8357 13.715C16.7868 13.7642 16.7204 13.7918 16.6512 13.7918C16.5821 13.7918 16.5157 13.7642 16.4668 13.715C16.4179 13.6659 16.3904 13.5992 16.3904 13.5297V13.0054C16.3904 12.9359 16.4179 12.8692 16.4668 12.82C16.5157 12.7709 16.5821 12.7432 16.6512 12.7432C16.7204 12.7432 16.7868 12.7709 16.8357 12.82C16.8846 12.8692 16.9121 12.9359 16.9121 13.0054V13.5297Z"
															fill="#EF4E58"
															className="path"
														/>
													</g>
													<defs>
														<clipPath id="clip0">
															<rect
																width="12.5185"
																height="15.7284"
																fill="white"
																transform="translate(6.74075 8.02472)"
															/>
														</clipPath>
													</defs>
												</svg>
												<p>
													Agency <br /> Admin
												</p>
											</div>
										)}
									{!verifyAuthToken(authToken, "admin") &&
										verifyAuthToken(authToken, "workbench") && (
											<div
												className={
													activeTool === "Travel Workbench"
														? "menu-item d-flex active flex-column align-items-center justify-content-between"
														: "menu-item d-flex flex-column align-items-center justify-content-between"
												}
												onClick={() => {
													setActiveTool("Travel Workbench");
													history.push("/workbench");
													setIsAppTrayOpen(false);
												}}
											>
												<svg
													width="33"
													height="19"
													viewBox="0 0 33 19"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M32.5 6.32592V2.68083C32.5 1.54759 31.597 0.628174 30.483 0.628174H2.51803C1.40303 0.628174 0.500031 1.54759 0.500031 2.68083V6.32592C2.23503 6.49901 3.59203 7.98861 3.59203 9.79995C3.59203 11.6113 2.23503 13.1009 0.500031 13.274V16.9181C0.500031 18.0523 1.40303 18.9717 2.51803 18.9717H30.484C31.597 18.9717 32.501 18.0533 32.501 16.9181V13.274C30.766 13.1009 29.409 11.6113 29.409 9.79995C29.409 7.98861 30.765 6.49901 32.5 6.32592ZM17.355 13.1182L16.684 14.3003C16.613 14.4266 16.47 14.4459 16.37 14.341L13.432 11.317C12.678 12.4462 11.965 13.4053 11.333 14.1354L12.37 15.9905C12.44 16.1178 12.439 16.3245 12.368 16.4517L12.139 16.8549C12.067 16.9822 11.92 17.0036 11.815 16.9069L10.117 15.3256C9.66003 15.6738 9.29203 15.797 9.04603 15.6514C8.80003 15.5058 8.72203 15.121 8.78803 14.5447L6.59503 13.837C6.45803 13.7922 6.40603 13.6528 6.47703 13.5255L6.70603 13.1223C6.77703 12.996 6.95403 12.8912 7.09803 12.8901L9.19503 12.8769C9.50003 11.9544 9.95903 10.8456 10.542 9.61566L6.50203 8.53843C6.36203 8.50177 6.30803 8.36635 6.37903 8.23908L7.04903 7.05799C7.12103 6.93072 7.29803 6.8289 7.44203 6.83195L11.975 6.91035C13.934 3.66134 15.346 3.20926 15.913 3.54323C16.479 3.87515 16.803 5.34643 15.018 8.69828L17.352 12.657C17.425 12.7853 17.427 12.992 17.355 13.1182ZM24.097 17.6277H21.475V15.0813H24.097V17.6277ZM24.097 13.2577H21.475V10.7102H24.097V13.2577ZM24.097 8.88766H21.475V6.34119H24.097V8.88766ZM24.097 4.51865H21.475V1.97217H24.097V4.51865Z"
														fill="#EF4E58"
														className="path"
													/>
												</svg>
												<p>
													Travel <br /> Workbench
												</p>
											</div>
										)}
									{!verifyAuthToken(authToken, "admin") &&
										verifyAuthToken(authToken, "inventory") && (
											<div
												className={
													activeTool === "Local Inventory"
														? "menu-item d-flex active flex-column align-items-center justify-content-between"
														: "menu-item d-flex flex-column align-items-center justify-content-between"
												}
												onClick={() => {
													setActiveTool("Local Inventory");
													history.push("/inventory");
													setIsAppTrayOpen(false);
												}}
											>
												<svg
													version="1.0"
													xmlns="http://www.w3.org/2000/svg"
													width="35"
													height="20"
													viewBox="0 0 76.000000 43.000000"
													preserveAspectRatio="xMidYMid meet"
												>
													<g
														transform="translate(0.000000,43.000000) scale(0.100000,-0.100000)"
														fill="#EF4E58"
														className="path"
													>
														<path
															d="M25 405 c-24 -23 -25 -28 -25 -170 0 -142 1 -147 25 -170 l24 -25
233 0 c199 0 237 -2 257 -16 33 -24 113 -21 149 5 68 48 88 137 44 198 -17 24
-22 45 -22 92 0 52 -4 66 -25 86 l-24 25 -306 0 -306 0 -24 -25z m129 -69
c-10 -17 -21 -23 -32 -19 -15 6 -15 5 -3 -11 13 -16 16 -15 37 11 l23 28 1
-37 0 -38 -45 0 -45 0 0 45 0 45 40 0 40 0 -16 -24z m346 9 c0 -13 -21 -15
-130 -15 -109 0 -130 2 -130 15 0 13 21 15 130 15 109 0 130 -2 130 -15z
m-100 -70 c0 -12 -16 -15 -80 -15 -64 0 -80 3 -80 15 0 12 16 15 80 15 64 0
80 -3 80 -15z m296 -39 c30 -30 34 -40 34 -86 0 -75 -45 -120 -120 -120 -46 0
-56 4 -86 34 -30 30 -34 40 -34 86 0 46 4 56 34 86 30 30 40 34 86 34 46 0 56
-4 86 -34z m-542 -60 c-10 -17 -21 -23 -32 -19 -15 6 -15 5 -3 -11 13 -16 16
-15 37 11 l23 28 1 -37 0 -38 -45 0 -45 0 0 45 0 45 40 0 40 0 -16 -24z m306
9 c0 -12 -19 -15 -110 -15 -91 0 -110 3 -110 15 0 12 19 15 110 15 91 0 110
-3 110 -15z m-60 -70 c0 -12 -16 -15 -80 -15 -64 0 -80 3 -80 15 0 12 16 15
80 15 64 0 80 -3 80 -15z"
														/>
														<path
															d="M590 201 c5 -11 10 -24 10 -30 0 -14 -37 -14 -45 -1 -12 19 -22 10
-21 -20 1 -30 10 -38 21 -20 3 6 15 10 27 10 21 0 21 -7 3 -55 -6 -14 5 -8 31
18 22 20 50 37 62 37 12 0 22 5 22 10 0 6 -13 10 -28 10 -20 0 -35 9 -50 30
-26 34 -49 42 -32 11z"
														/>
													</g>
												</svg>
												<p>
													Local <br /> Inventory
												</p>
											</div>
										)}
								</div>
							</OutsideClickHandler>
						</div>
					</div>
				)}
			</div>
			<div className="header-right d-flex align-items-center flex-grow-1 justify-content-between">
				{!isEmpty(authToken) && (
					<div className="user-type d-flex align-items-center">
						<p className="cursor-pointer" onClick={() => history.push("/home")}>
							Home :
						</p>
						<p className="m-l-5 agency-name">
							{currentUser?.memberSet?.edges[0]?.node?.organization?.name || ""}
						</p>
					</div>
				)}
				<div className="ml-auto">
					{isEmpty(authToken) ? (
						<Link
							to={"/auth/login"}
							className="btn btn--secondary ml-auto btn--small"
						>
							Login
						</Link>
					) : (
						<div className="header-menu d-flex align-content-center ml-auto m-t-5">
							<div className="header-menu__list m-l-20">
								<i
									className="material-icons"
									onClick={() => history.push("/home/notifications")}
								>
									notifications
								</i>
							</div>
							<div className="header-menu__list m-l-20">
								<i
									className="material-icons"
									onClick={() => setIsProfileOpen(!isprofileOpen)}
								>
									account_circle
								</i>
								<div
									className={
										isprofileOpen
											? "profile-dropdown dropdown"
											: "profile-dropdown dropdown d-none"
									}
								>
									<OutsideClickHandler
										onOutsideClick={() => {
											setIsProfileOpen(false);
										}}
									>
										<div className="username">
											{currentUser.firstName} {currentUser.lastName}
											<p>
												{currentUser?.memberSet?.edges[0]?.node?.role?.name}
											</p>
										</div>
										<div className="profile-menu">
											<Link
												to={`${HOME_ROUTES}/my-profile`}
												className="m-b-15"
												onClick={() => setIsProfileOpen(!isprofileOpen)}
											>
												My Profile
											</Link>
											<Link
												to={`${HOME_ROUTES}/change-password`}
												className="m-b-15"
												onClick={() => setIsProfileOpen(!isprofileOpen)}
											>
												Change Password
											</Link>
											<Link
												to={`#`}
												className="m-b-5"
												onClick={async (event) => {
													event.preventDefault();
													await clearAuthToken();
													await clearRefreshToken();
													setIsProfileOpen(!isprofileOpen);
													history.push("/");
												}}
											>
												Logout
											</Link>
										</div>
										<div className="last-login">
											<p>
												Last Login:{" "}
												{moment(currentUser.lastLogin).format("lll")}
											</p>
										</div>
									</OutsideClickHandler>
								</div>
							</div>
						</div>
					)}
				</div>
			</div>
		</header>
	);
};

export default Header;
